import React, { Children } from 'react';
import { ArrowLeftIcon } from 'lucide-react';
export function ReservationDetail() {
  const reservation = {
    pnr: 'FRU91DGE',
    status: 'confirmed',
    date: {
      checkIn: '10 Nov 2025',
      checkOut: '11 Nov 2025',
      nights: 1
    },
    guests: {
      adults: 2,
      children: 0,
      infants: 0,
      rooms: 1
    },
    booking: {
      id: '68d67b3d2e37218960b356f',
      transactionId: '68d67b3dd025cb0f2d99f912'
    },
    hotel: {
      name: 'BML Paradise Shores Resort',
      id: '689eeaf67b0e1e34cf4940b8'
    },
    room: {
      name: 'Premium Overwater Villa',
      view: 'SEA_VIEW',
      category: 'OVERWATER_VILLA'
    },
    guest: {
      name: 'Ahmed Waheed',
      email: 'sujau@bml.com.my',
      phone: '+9607908663',
      passport: 'saaa',
      dateOfBirth: '25 Feb 2017',
      nationality: 'MDV',
      specialRequests: ''
    },
    rate: {
      name: 'Advance Booking with Free Seaplan Transfer',
      description: 'Plan your Maldivan escape early and enjoy the added luxury of a complimentary round-trip seaplane transfer from Malé to the resort. This exclusive offer rewards advance planners with both value and convenience, ensuring your journey is as seamless as your stay. Book 14 days in advance.'
    },
    price: {
      subtotal: '$1.00',
      serviceCharge: '$0.10'
    }
  };
  const navigateBack = () => {
    window.location.href = '/reservations';
  };
  return <div className="space-y-6" data-id="element-10377">
      {/* Header with back button */}
      <div className="flex items-center space-x-2" data-id="element-10378">
        <button onClick={navigateBack} className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-10379">
          <ArrowLeftIcon size={18} className="mr-1" data-id="element-10380" />
          <span data-id="element-10381">Reservation Details</span>
        </button>
      </div>
      {/* Reservation Details Card */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-10382">
        {/* Reservation Header */}
        <div className="p-6 border-b border-gray-200" data-id="element-10383">
          <div className="flex justify-between items-center" data-id="element-10384">
            <h2 className="text-xl font-bold" data-id="element-10385">{reservation.pnr}</h2>
            <div className="flex space-x-4" data-id="element-10386">
              <span className="px-3 py-1 bg-green-100 text-green-800 text-sm font-semibold rounded-full" data-id="element-10387">
                Confirmed
              </span>
              <button className="px-4 py-2 border border-red-500 text-red-500 rounded-md hover:bg-red-50" data-id="element-10388">
                Resend confirmation email
              </button>
            </div>
          </div>
        </div>
        {/* Reservation Overview */}
        <div className="grid grid-cols-1 md:grid-cols-2 border-b border-gray-200" data-id="element-10389">
          <div className="p-6 border-r border-gray-200" data-id="element-10390">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-10391">Date</h3>
            <p className="text-gray-900 font-medium" data-id="element-10392">
              {reservation.date.checkIn} - {reservation.date.checkOut}
            </p>
            <p className="text-sm text-gray-500" data-id="element-10393">
              {reservation.date.nights} Nights
            </p>
          </div>
          <div className="p-6" data-id="element-10394">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-10395">
              Guests & Rooms
            </h3>
            <p className="text-gray-900 font-medium" data-id="element-10396">
              {reservation.guests.adults} Adults, {reservation.guests.children}{' '}
              Children, {reservation.guests.infants} Infants
            </p>
            <p className="text-sm text-gray-500" data-id="element-10397">
              {reservation.guests.rooms} Room
            </p>
          </div>
        </div>
        {/* Booking Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-10398">
          <h3 className="text-sm font-semibold mb-4" data-id="element-10399">Booking Information</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-10400">
            <div data-id="element-10401">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10402">Booking ID</p>
              <p className="text-sm text-gray-900" data-id="element-10403">{reservation.booking.id}</p>
            </div>
            <div data-id="element-10404">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10405">Transaction ID</p>
              <p className="text-sm text-gray-900" data-id="element-10406">
                {reservation.booking.transactionId}
              </p>
            </div>
          </div>
        </div>
        {/* Hotel Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-10407">
          <h3 className="text-sm font-semibold mb-4" data-id="element-10408">Hotel</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-10409">
            <div data-id="element-10410">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10411">Name</p>
              <p className="text-sm text-gray-900" data-id="element-10412">{reservation.hotel.name}</p>
            </div>
            <div data-id="element-10413">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10414">Hotel ID</p>
              <p className="text-sm text-gray-900" data-id="element-10415">{reservation.hotel.id}</p>
            </div>
          </div>
        </div>
        {/* Room Type Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-10416">
          <h3 className="text-sm font-semibold mb-4" data-id="element-10417">Room Type</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-10418">
            <div data-id="element-10419">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10420">Name</p>
              <p className="text-sm text-gray-900" data-id="element-10421">{reservation.room.name}</p>
            </div>
            <div data-id="element-10422">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10423">View</p>
              <p className="text-sm text-gray-900" data-id="element-10424">{reservation.room.view}</p>
            </div>
            <div data-id="element-10425">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10426">Category</p>
              <p className="text-sm text-gray-900" data-id="element-10427">
                {reservation.room.category}
              </p>
            </div>
          </div>
        </div>
        {/* Guest Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-10428">
          <h3 className="text-sm font-semibold mb-4" data-id="element-10429">Guest Information</h3>
          <div className="border border-gray-200 rounded-lg p-4" data-id="element-10430">
            <h4 className="text-base font-medium mb-4" data-id="element-10431">
              {reservation.guest.name}
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-10432">
              <div data-id="element-10433">
                <p className="text-sm text-gray-500 mb-1" data-id="element-10434">Email</p>
                <p className="text-sm text-gray-900" data-id="element-10435">
                  {reservation.guest.email}
                </p>
              </div>
              <div data-id="element-10436">
                <p className="text-sm text-gray-500 mb-1" data-id="element-10437">Phone number</p>
                <p className="text-sm text-gray-900" data-id="element-10438">
                  {reservation.guest.phone}
                </p>
              </div>
              <div data-id="element-10439">
                <p className="text-sm text-gray-500 mb-1" data-id="element-10440">Passport number</p>
                <p className="text-sm text-gray-900" data-id="element-10441">
                  {reservation.guest.passport}
                </p>
              </div>
              <div data-id="element-10442">
                <p className="text-sm text-gray-500 mb-1" data-id="element-10443">Date of birth</p>
                <p className="text-sm text-gray-900" data-id="element-10444">
                  {reservation.guest.dateOfBirth}
                </p>
              </div>
              <div data-id="element-10445">
                <p className="text-sm text-gray-500 mb-1" data-id="element-10446">Nationality</p>
                <p className="text-sm text-gray-900" data-id="element-10447">
                  {reservation.guest.nationality}
                </p>
              </div>
              <div data-id="element-10448">
                <p className="text-sm text-gray-500 mb-1" data-id="element-10449">Special Requests</p>
                <p className="text-sm text-gray-900" data-id="element-10450">
                  {reservation.guest.specialRequests || 'None'}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Rate Details */}
        <div className="p-6 border-b border-gray-200" data-id="element-10451">
          <h3 className="text-sm font-semibold mb-4" data-id="element-10452">Rate Details</h3>
          <div className="grid grid-cols-1 gap-4" data-id="element-10453">
            <div data-id="element-10454">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10455">Rate Name</p>
              <p className="text-sm text-gray-900" data-id="element-10456">{reservation.rate.name}</p>
            </div>
            <div data-id="element-10457">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10458">Description</p>
              <p className="text-sm text-gray-900" data-id="element-10459">
                {reservation.rate.description}
              </p>
            </div>
          </div>
        </div>
        {/* Price Breakdown */}
        <div className="p-6" data-id="element-10460">
          <h3 className="text-sm font-semibold mb-4" data-id="element-10461">Price Breakdown</h3>
          <div className="space-y-3" data-id="element-10462">
            <div className="flex justify-between" data-id="element-10463">
              <p className="text-sm text-gray-500" data-id="element-10464">Subtotal</p>
              <p className="text-sm text-gray-900" data-id="element-10465">
                {reservation.price.subtotal}
              </p>
            </div>
            <div className="flex justify-between" data-id="element-10466">
              <p className="text-sm text-gray-500" data-id="element-10467">Service charge</p>
              <p className="text-sm text-gray-900" data-id="element-10468">
                {reservation.price.serviceCharge}
              </p>
            </div>
            <div className="border-t border-gray-200 pt-3 flex justify-between" data-id="element-10469">
              <p className="text-sm font-medium" data-id="element-10470">Total</p>
              <p className="text-sm font-bold" data-id="element-10471">$1.10</p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}